// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__Y8wfI","approved":"Status_approved__42P7T","rejected":"Status_rejected__2ZOnm","expired":"Status_expired__TWxsR","label":"Status_label__2U_Gd"};